import React from 'react';
import moment from 'moment';

const COL_TYPES = {
  SIMPLE: 'simple',
  PERCENT: 'percent',
  DATE: 'date',
  FLOAT: 'float',
};

function generateCellContent(value, column, asHTML = true) {
  const { colType, posClass, negClass } = column;
  if (value === null || value === undefined) {
    return '';
  }
  if (value !== '-') {
    if (colType === COL_TYPES.FLOAT || colType === COL_TYPES.PERCENT) {
      let numericValue = value;
      if (typeof value === 'string') {
        if (colType === COL_TYPES.PERCENT) {
          numericValue = value.endsWith('%') ? value.slice(0, value.length - 1) : value;
        }
        numericValue = parseFloat(numericValue, 10);
      }
      if (asHTML && numericValue > 0) {
        return (<span className={posClass}>{numericValue.toFixed(2)}</span>);
      }
      if (asHTML && numericValue < 0) {
        return (<span className={negClass}>{numericValue.toFixed(2)}</span>);
      }
      return numericValue.toFixed(2);
    }
  }
  return value;
}

function processColumn(column) {

  const {
    id = null,
    Header,
    field,
    colType = COL_TYPES.SIMPLE,
  } = column;

  if (colType === COL_TYPES.PERCENT) {
    return (
      {
        id: id || Header,
        Header,
        accessor: d => (Number.isNaN(parseFloat(d[field]))
          ? '-'
          : (parseFloat(d[field], 10)).toFixed(2) + '%'),
        Cell: props => generateCellContent(props.value, column),
        sortMethod: (a, b, _desc) => {
          const aNumeric = parseFloat(a.endsWith('%') ? a.slice(0, a.length - 1) : Number.POSITIVE_INFINITY);
          const bNumeric = parseFloat(b.endsWith('%') ? b.slice(0, b.length - 1) : Number.POSITIVE_INFINITY);
          if (aNumeric > bNumeric) {
            return 1;
          }
          if (aNumeric < bNumeric) {
            return -1;
          }
          return 0;
        },
      }
    );
  }

  if (colType === COL_TYPES.DATE) {
    return (
      {
        id: id || Header,
        Header,
        accessor: d => moment.utc(d[field])
          .format('MMM DD, YYYY'),
        sortMethod: (a, b, _desc) => {
          const aDate = moment.utc(a);
          const bDate = moment.utc(b);
          if (aDate > bDate) {
            return 1;
          }
          if (aDate < bDate) {
            return -1;
          }
          return 0;
        },
      }
    );
  }

  if (colType === COL_TYPES.FLOAT) {
    return (
      {
        id: id || Header,
        Header,
        accessor: d => (Number.isNaN(parseFloat(d[field]))
          ? '-'
          : (parseFloat(d[field], 10))),
        Cell: props => generateCellContent(props.value, column),
        sortMethod: (a, b, _desc) => {
          const aNum = parseFloat(a, 10);
          const bNum = parseFloat(b, 10);
          if (aNum > bNum) {
            return 1;
          }
          if (aNum < bNum) {
            return -1;
          }
          return 0;
        },
      }
    );
  }

  // COL_TYPES.SIMPLE
  return (
    {
      id: id || Header,
      Header,
      accessor: field,
    }
  );
}

export default ({ COL_TYPES, generateCellContent, processColumn });
